import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { I18nProvider } from "./lib/i18n";
import { FxProvider } from "./lib/fx";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ConciergeWidget from "./components/ConciergeWidget";
import HomePage from "./pages/HomePage";
import DestinationPage from "./pages/DestinationPage";
import DestinationsIndex from "./pages/DestinationsIndex";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import CustomTripPage from "./pages/CustomTripPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import BecomeProviderPage from "./pages/BecomeProviderPage";
import BecomeAffiliatePage from "./pages/BecomeAffiliatePage";
import DashboardRouter from "./pages/DashboardRouter";
import ProfilePage from "./pages/ProfilePage";
import WalletPage from "./pages/WalletPage";
import ProviderPublicPage from "./pages/ProviderPublicPage";
import CookieConsentBanner from "./components/CookieConsentBanner";

export default function App() {
  const [conciergeOpen, setConciergeOpen] = useState(false);
  const location = useLocation();
  const hideChrome = ["/login", "/signup"].includes(location.pathname);

  return (
    <I18nProvider>
      <AuthProvider>
        <FxProvider>
        <div className="min-h-screen flex flex-col">
        {!hideChrome && <Header onOpenConcierge={() => setConciergeOpen(true)} />}
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage onOpenConcierge={() => setConciergeOpen(true)} />} />
            <Route path="/destinations" element={<DestinationsIndex />} />
            <Route path="/destinations/:slug" element={<DestinationPage onOpenConcierge={() => setConciergeOpen(true)} />} />
            <Route path="/services/:id" element={<ServiceDetailPage />} />
            <Route path="/custom-trip" element={<CustomTripPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/become-provider" element={<BecomeProviderPage />} />
            <Route path="/become-affiliate" element={<BecomeAffiliatePage />} />
            <Route path="/dashboard" element={<DashboardRouter />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/wallet" element={<WalletPage />} />
            <Route path="/p/:slug" element={<ProviderPublicPage />} />
            <Route path="*" element={
              <div className="pt-40 px-6 max-w-3xl mx-auto text-center">
                <div className="font-script text-5xl text-teal mb-4">Lost in transit.</div>
                <p className="text-muted">The page you're looking for doesn't exist.</p>
              </div>
            } />
          </Routes>
        </main>
        {!hideChrome && <Footer />}
        <CookieConsentBanner />
        {!hideChrome && (
          <ConciergeWidget
            open={conciergeOpen}
            onClose={(closed) => setConciergeOpen(!closed ? true : false)}
          />
        )}
      </div>
      </FxProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
